"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var S={SUCCESS:"success",FAILURE:"failure",CANCELED:"canceled"},e="73";exports.CASUAL_USER_ALLOW_EXPORT=e;exports.STATUS=S;
